// Version-agnostic config constants shared by v1 and v2.

export type ServiceConfigsValues = Record<string, unknown>

export const ServiceConfigItemTypes = {
  STRING: 'string',
  BOOL: 'bool',
  DATE: 'date',
  CHOICE: 'choice',
  TEXT: 'text',
} as const

export type ServiceConfigItemType = (typeof ServiceConfigItemTypes)[keyof typeof ServiceConfigItemTypes]
